import React, {useState} from "react";
import StepContent from "./step-content";
import Plans from "./plans";
import * as Yup from "yup";
import { OptionalString, RequiredBoolean, RequiredString } from "./form_elements/form-validators";
import { useDispatch, useSelector } from "react-redux";
import { updateSelection } from "../redux/actions/enrollments-actions";
import useMsalApi from "./use-msal-api";
import { format, parseISO } from "date-fns";


const HealthPlan = ({pageStep, defaultPlanId, defaultPlanDescription, waivedOption, planType}) => {
    const [callApi] = useMsalApi();
    const dispatch = useDispatch();
    const enrollments = useSelector(s => s.enrollments);
    const [reset, setReset] = useState(false);
    const [disabled,setDisabled] = useState(true);

  
    const validationSchema = Yup.object().shape({
      planId: RequiredString("Required"),
      planDescription: RequiredString("Required"),
      planOption: OptionalString().test('waived-option', 'Required',
        (item, ctx) => {
          return ctx.parent.planId === 'WAIVED' || item != null;
        }
      ),
      dependents: Yup.array().of(Yup.object().shape({
          id: RequiredString("Required"),
          enrolled : RequiredBoolean("Required")
        })
      ).test('has-spouse', 'You must select your spouse/domestic partner for this tier.',
        (item, ctx) => {
          var options = ["3", "4"];
          if(options.includes(ctx.parent.planOption))
          {
            var relationships = item?.filter(s => s.enrolled === true).map(d => d.relationship.id);
            return relationships?.includes("D") || relationships?.includes("S");
          } else {
            return true;
          }
        }
  
      ).test('has-children', 'You must select a child/domestic partner child for this tier.',
      (item, ctx) => {
        var options = ["2", "4"];
        if(options.includes(ctx.parent.planOption))
        {
          var relationships = item?.filter(s => s.enrolled === true).map(d => d.relationship.id);
          return relationships?.includes("C") || relationships?.includes("R");
        } else {
          return true;
        }
      }
  
    )
    });

  
    const onSubmit = async (formData) => {
      console.log(formData);
      const frm = validationSchema.cast(formData);
  
      const params = {
          planId: frm.planId,
          planDescription: frm.planDescription,
          planOption: frm.planOption,
          planType: planType
      }
      if(frm.dependents && frm.dependents.length > 0){
        params.dependents = [];
        frm.dependents.filter((s) => s.enrolled === true).forEach((d) => {
          params.dependents.push(d.id);
        });
      }
      if(params.planId === 'WAIVED'){
        params.planId = defaultPlanId;
        params.planDescription = defaultPlanDescription;
        params.planOption =waivedOption;
        params.dependents=[];
      }

      const results = await callApi(`Enrollments/${enrollments.id}/health/${enrollments.employee.id}/${format(
        parseISO(enrollments.effectiveDate),
        "yyyy-MM-dd"
      )}`, "PATCH", params);
      if(!results.error){
          dispatch(updateSelection(results));
      }
  };
  
    const onError = (errors, e) => {
      console.log("Form Submission Error", errors);
    };

    const onReset = () => {
      setReset(!reset);
  }
  
    return (
      <> 
        <StepContent pageStep={pageStep} schema={validationSchema} onSubmit={onSubmit} onError={onError} onReset={onReset} disabled={disabled}>
          <Plans type={planType} reset={reset} setDisabled={setDisabled}/>
        </StepContent>
      </>
    );
  }
 
export default HealthPlan;